import {
  Box,
  Grid2,
  IconButton,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import makeFullUrl from "../../utils/cloudinary";
import { getDisplayImageUrls } from "../../utils/images";

function ImageGrid(props) {
  const { data: property } = props;
  // const mainImageUrl = `${process.env.REACT_APP_SERVER_URL}/${property.mainImage.filePath}`;
  const mainImageUrl = makeFullUrl(
    property.mainImage.filePath,
    property.mainImage.fileType
  );

  // Return images filePath if exist else mainImage
  // if images count is less than 4, then return first element of images array
  const finalImages = getDisplayImageUrls(property.mainImage, property.images);

  const imagesUrl =
    property?.images?.length > 0
      ? property.images
          .flat()
          // .map((img) => `${process.env.REACT_APP_SERVER_URL}/${img.filePath}`)
          .map((img) => makeFullUrl(img.filePath, img.fileType))
      : [];

  // {
  //   finalImages.map((src, index) => console.log(20001, src, index));
  // }

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  // Custom arrow components
  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronRight fontSize="large" />
      </IconButton>
    );
  };

  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <IconButton
        onClick={onClick}
        sx={{
          position: "absolute",
          left: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "white",
          bgcolor: "rgba(0,0,0,0.5)",
          "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
        }}
      >
        <ChevronLeft fontSize="large" />
      </IconButton>
    );
  };

  const dialogSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (current, next) => setActiveImageIndex(next),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor:
            i === activeImageIndex ? "#fff" : "rgba(255,255,255,0.5)",
          margin: "0 4px",
          cursor: "pointer",
        }}
      />
    ),
  };

  return (
    <>
      <Grid2 container spacing={1}>
        {/* Left Large Image */}
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              height: "calc(2 * 200px + 8px)", // 2 rows of images (400px) + spacing (8px)
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: "8px",
              // borderRadius: "8px 0 0 8px",
              backgroundColor: "#f5f5f5", // Fallback background for empty spaces
            }}
            onClick={() => {
              setIsGalleryOpen(true);
            }}
          >
            <img
              src={mainImageUrl}
              alt="Main Property"
              style={{
                width: "100%",
                height: "100%", // Ensure full container height
                objectFit: "cover", // Maintain aspect ratio
                // borderRadius: "8px",
                cursor: "pointer",
              }}
            />
          </Box>
        </Grid2>

        {/* Right Smaller Images */}
        <Grid2
          container
          size={{ xs: 12, md: 6 }}
          spacing={1}
          sx={{
            position: "relative",
          }}
        >
          {finalImages.map((src, index) => (
            <Grid2 size={{ xs: 6 }} key={index}>
              <Box
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  height: "200px", // Fixed height for thumbnails
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderRadius: "8px",
                  borderTopLeftRadius: index === 0 ? "8px" : "0", // Apply border to top-left image
                  borderTopRightRadius: index === 1 ? "8px" : "0", // Apply border to top-right image
                  borderBottomLeftRadius: index === 2 ? "8px" : "0", // Apply border to bottom-left image
                  borderBottomRightRadius: index === 3 ? "8px" : "0", // Apply border to bottom-right image
                  backgroundColor: "#f5f5f5", // Fallback background for empty spaces
                }}
                onClick={() => {
                  setIsGalleryOpen(true);
                }}
              >
                <img
                  src={src}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // Ensure images don't distort
                    // borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
              </Box>
            </Grid2>
          ))}

          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              bgcolor: "rgba(0,0,0,0.3)",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.5)",
              },
            }}
            onClick={() => {
              setIsGalleryOpen(true);
            }}
          >
            <FullscreenIcon />
          </IconButton>
        </Grid2>
      </Grid2>

      {/* Image Gallery Dialog */}
      <Dialog
        open={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          {property.title} Gallery
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => setIsGalleryOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Slider {...dialogSliderSettings} initialSlide={activeImageIndex}>
            {[mainImageUrl, ...imagesUrl].map((img, idx) => (
              <div key={idx}>
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Property ${idx + 1}`}
                  sx={{ maxHeight: "70vh", objectFit: "contain" }}
                />
              </div>
            ))}
          </Slider>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ImageGrid;
